import { useAppSelector } from '@hooks/app/redux';
import { getEVisitsEvents } from '@services/e-visits';
import moment from 'moment';
import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';
import { GetEvisitEventsParams } from 'types/e-visits';

async function handler(providerId: string, params: GetEvisitEventsParams) {
  const { data } = await getEVisitsEvents(providerId, params);
  return data.data;
}

type TQueryData = Awaited<ReturnType<typeof handler>>;

function useDailyEvents(
  params: GetEvisitEventsParams = {
    fromDate: moment().startOf('day').toISOString(),
    toDate: moment().endOf('day').toISOString(),
    occupied: true,
  },
  options?: UseQueryOptions<TQueryData, unknown, TQueryData, any[]>,
) {
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  return useQuery(
    ['calendar:dailyEvents', params, providerId],
    () => handler(providerId, params),
    options,
  );
}

export default useDailyEvents;
